import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { FiAward, FiPlusCircle, FiExternalLink } from "react-icons/fi";
import scholarshipService from "../services/scholarshipService";

const STATUS_BADGE = {
    Applied: <span className="badge" style={{ background: "#e2e8f0", color: "#475569" }}>Applied</span>,
    Approved: <span className="badge" style={{ background: "#fef3c7", color: "#b45309" }}>Approved</span>,
    Disbursed: <span className="badge badge-green">Disbursed</span>,
    Rejected: <span className="badge" style={{ background: "#fee2e2", color: "#b91c1c" }}>Rejected</span>,
};

// Usage: <StudentScholarships studentId={student._id} />
// Drop this into StudentView.jsx as a tab/section.
export default function StudentScholarships({ studentId }) {
    const [scholarships, setScholarships] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!studentId) return;
        (async () => {
            setLoading(true);
            try {
                const res = await scholarshipService.getByStudent(studentId);
                setScholarships(res.data || []);
            } catch (err) {
                toast.error(err.message);
            } finally {
                setLoading(false);
            }
        })();
    }, [studentId]);

    return (
        <div className="card">
            <div className="card-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <strong>Scholarships</strong>
                <Link to={`/scholarships/add?studentId=${studentId}`} className="btn btn-outline btn-sm">
                    <FiPlusCircle size={12} style={{ marginRight: 4 }} />
                    Add
                </Link>
            </div>
            <div className="card-body" style={{ padding: 0 }}>
                {loading ? (
                    <div className="loading-center">
                        <div className="spinner" />
                    </div>
                ) : scholarships.length === 0 ? (
                    <div className="empty-state">
                        <FiAward />
                        <p>No scholarship records for this student.</p>
                    </div>
                ) : (
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Scheme</th>
                                    <th>Sanctioned</th>
                                    <th>Disbursed</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {scholarships.map((s) => (
                                    <tr key={s._id}>
                                        <td>{s.academicYear?.label || "—"}</td>
                                        <td>{s.schemeType}</td>
                                        <td>₹{s.sanctionedAmount.toLocaleString("en-IN")}</td>
                                        <td>₹{s.disbursedAmount.toLocaleString("en-IN")}</td>
                                        <td>{STATUS_BADGE[s.status] || s.status}</td>
                                        <td>
                                            {s.sanctionLetterUrl && (
                                                <a href={s.sanctionLetterUrl} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm">
                                                    <FiExternalLink size={12} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}